import { createIcon } from '@chakra-ui/react';

export const LinkedinIcon = createIcon({
  displayName: 'LinkedinIcon',
  viewBox: '0 0 50 50',
  path: [
    <path
      key="1"
      d="M46.2958 0.00372828H3.68956C1.6759 -0.0189964 0.0245756 1.59402 0 3.6077V46.3916C0.0237342 48.4062 1.67492 50.0209 3.68956 49.9997H46.2958C48.3144 50.0247 49.9721 48.4102 50 46.3916V3.60462C49.9712 1.58696 48.3134 -0.0259691 46.2958 0.000316773"
      fill="#0A66C2"
    />,
    <path
      key="2"
      d="M35.1939 42.6033H42.6023L42.6054 29.5147C42.6054 23.0893 41.221 18.1503 33.7122 18.1503C30.8417 18.0437 28.1452 19.5247 26.695 22.0043H26.5955V18.7437H19.4834V42.6025H26.8918V30.7997C26.8918 27.6873 27.4822 24.6729 31.3407 24.6729C35.1445 24.6729 35.1939 28.2344 35.1939 31.0011V42.6033Z"
      fill="white"
    />,
    <path
      key="3"
      d="M6.82422 11.1839C6.82465 13.5583 8.74981 15.4828 11.1242 15.4824C12.2644 15.4822 13.3579 15.029 14.164 14.2226C14.9701 13.4162 15.4228 12.3226 15.4226 11.1823C15.4222 8.80788 13.497 6.88336 11.1227 6.88379C8.74827 6.88422 6.82379 8.80942 6.82422 11.1839Z"
      fill="white"
    />,
    <path
      key="4"
      d="M7.41226 42.6033H14.8284V18.7437H7.41226V42.6033Z"
      fill="white"
    />
  ]
});
